export default __webpack_public_path__ + "static/media/hamburger.17ace9b6.svg";